import React, { useMemo } from "react";
import { IoCloudUpload } from "react-icons/io5";
import ToggleIconButton from "../../../components/buttons/toggleIconButton";
import { useEffect, useState } from "react";
import { useTheme } from "../../../context/useThemeContext";
import styled from "styled-components";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import useMainStore from "../../../stores/mainStore";
import syncChangesToCloud from "../../../utility/backend/syncChangesToCloud";

export function SyncButton() {
    const { theme } = useTheme();
    const userData = useAccountManagementStore((state) => state.userData);

    const isUploadingArray = useMemo(() => [], []);
    const isUploading = useMainStore(
        (state) => state.data?.syncState?.isUploading ?? isUploadingArray
    );
    const changesMadeArray = useMemo(() => [], []);
    const changesMade = useMainStore(
        (state) => state.data?.syncState?.changesMade ?? changesMadeArray
    );

    async function SyncWithCloud() {
        // If there are changes made and no uploads are in progress
        if (changesMade.length > 0 && isUploading.length === 0) {
            syncChangesToCloud(undefined, true);
        }
    }

    if (!userData?.id || userData?.id === "default")
        return null;

    return (
        <div
            className="relative"
            style={{
                pointerEvents:
                    changesMade.length > 0 && isUploading.length === 0
                        ? "all"
                        : "none",
            }}
        >
            <ToggleIconButton
                alt="Sync with cloud"
                icon={
                    <div className="relative z-10">
                        <IoCloudUpload size={17} />
                        <div
                            className="absolute right-[-4px] top-[-4px] h-2 w-2 rounded-full transition-[.5s] ease-in-out"
                            style={{
                                backgroundColor: theme.accentColor,

                                opacity: changesMade.length > 0 ? 1 : 0,
                            }}
                        />
                    </div>
                }
                size={{ x: 28, y: 28 }}
                className="flex w-[28px] items-center justify-center overflow-hidden"
                inactiveIconColor={
                    changesMade.length > 0
                        ? theme.fontColor[50]
                        : theme.fontColor[200]
                }
                hoverIconInactive={theme.fontColor[50]}
                hoverBGInactive={theme.secondaryHeaderColor}
                onClick={() => {
                    SyncWithCloud();
                }}
            />
            <BorderRadial
                $pulseColor={theme.accentColor}
                $showBorder={isUploading.length > 0}
            />
        </div>
    );
}

const BorderRadial = styled.div<{ $pulseColor: string; $showBorder: boolean }>`
    @property --angle {
        syntax: "<angle>";
        initial-value: 0deg;
        inherits: false;
    }

    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    border: 2px solid transparent;
    border-radius: 4px;
    transition: opacity 0.2s ease-in-out;
    opacity: ${(props) => (props.$showBorder ? "1" : "0")};

    background-image: linear-gradient(#202024d3, #202024d3),
        linear-gradient(
            var(--angle),
            transparent,
            transparent,
            ${(props) => props.$pulseColor},
            ${(props) => props.$pulseColor},
            transparent,
            transparent
        );

    background-origin: border-box;
    background-clip: content-box, border-box;
    animation: rotateBorder 3s cubic-bezier(0.35, 0.41, 0.57, 0.7) infinite;
    pointer-events: none;

    @keyframes rotateBorder {
        0% {
            --angle: 0deg;
        }
        100% {
            --angle: 360deg;
        }
    }
`;
